
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team-members",
      function () {
        return require("private-next-pages/team-members/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team-members"])
      });
    }
  